﻿<div class="cm-help" [ngClass]="{'cm-help-admin': isAdmin(), 'cm-help-empty': !isSet}" *ngIf="helpId">
	<span (click)="onEditClick()" class="clickable" *ngIf="isAdmin()">
	  <i class="fa fa-pencil" aria-hidden="true"></i>
  </span>
	<a *ngIf="isSet" class="button" href="{{help.url}}" target="_blank" title="{{help.title}}">
    <i class="fa fa-question fa-2x" aria-hidden="true"></i>
	</a>
	<i *ngIf="!isSet && isAdmin()" class="fa fa-question fa-2x" aria-hidden="true"></i>
</div>
